import React from 'react';
import Avatar from '../common/Avatar';
import { User } from '../../types';

export interface ActivityItem {
  id: string;
  user: User;
  action: string;
  target?: string;
  timestamp: string;
  icon?: string;
}

interface ActivityFeedProps {
  activities?: ActivityItem[];
  maxItems?: number;
}

const mockActivities: ActivityItem[] = [
  {
    id: '1',
    user: {
      id: 'user1',
      username: 'john.smith',
      email: 'john@example.com',
      initials: 'JS',
    },
    action: 'created a new case',
    target: 'Contract Dispute - Tech Corp',
    timestamp: '2 hours ago',
    icon: 'fas fa-folder-plus',
  },
  {
    id: '2',
    user: {
      id: 'user2',
      username: 'sarah.jones',
      email: 'sarah@example.com',
      initials: 'SJ',
    },
    action: 'uploaded a document',
    target: 'Merger Agreement Draft.pdf',
    timestamp: '4 hours ago',
    icon: 'fas fa-file-upload',
  },
  {
    id: '3',
    user: {
      id: 'user3',
      username: 'mike.wilson',
      email: 'mike@example.com',
      initials: 'MW',
    },
    action: 'completed a task',
    target: 'Client Meeting Preparation',
    timestamp: '6 hours ago',
    icon: 'fas fa-check-circle',
  },
  {
    id: '4',
    user: {
      id: 'user1',
      username: 'john.smith',
      email: 'john@example.com',
      initials: 'JS',
    },
    action: 'assigned a case',
    target: 'New Client Onboarding - Acme Corp',
    timestamp: '1 day ago',
    icon: 'fas fa-user-plus',
  },
];

const ActivityFeed: React.FC<ActivityFeedProps> = ({
  activities = mockActivities,
  maxItems = 5,
}) => {
  const displayActivities = activities.slice(0, maxItems);

  return (
    <div className="relative flex flex-col min-w-0 break-words dashboard-card rounded-2xl bg-clip-border">
      <div className="p-4 pb-0 mb-0 bg-transparent border-b-0 rounded-t-2xl">
        <h6 className="mb-0 font-semibold leading-normal text-lg text-slate-700">Recent Activity</h6>
      </div>
      <div className="flex-auto p-4">
        <ul className="flex flex-col pl-0 mb-0">
          {displayActivities.map((activity) => (
            <li key={activity.id} className="relative flex items-center px-0 py-2 mb-2 border-0 rounded-t-lg">
              <div className="flex items-center">
                <Avatar user={activity.user} size="small" className="mr-3" />
                <div className="flex flex-col">
                  <h6 className="mb-1 text-sm font-semibold leading-normal text-slate-700">
                    <span className="font-semibold">{activity.user.username}</span>
                    {' '}
                    <span className="font-normal text-slate-500">{activity.action}</span>
                    {activity.target && (
                      <span className="font-semibold text-slate-700"> {activity.target}</span>
                    )}
                  </h6>
                  <p className="mb-0 text-xs leading-tight text-slate-500">
                    <i className="fas fa-clock mr-1"></i>
                    {activity.timestamp}
                  </p>
                </div>
              </div>
              {activity.icon && (
                <div className="ml-auto">
                  <div className="inline-flex items-center justify-center w-8 h-8 text-xs text-white bg-primary-700 rounded-lg">
                    <i className={activity.icon}></i>
                  </div>
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ActivityFeed;
